<template>
    <div class="d-flex flex-row pdt-16 pdl-8 pdr-8">
        <!-- {{review.reviewer.profile}} -->
        <div class="mgl-8 mgr-8 profile">
            <img :src="review.reviewer.profile ? review.reviewer.profile : require('@/images/icon/person_icon1.png')" class="circle profile">
            <!-- <img src="@/images/icon/person_icon1.png"> -->
        </div>
        <div class="mgl-8 mgr-8 t-color-content1">
            <div class="t-helper">
                <span v-for="i in 5" :key="i" class="t-color-yellow" :class="i <= review.score ? 'on' : ''">★</span>
            </div>
            <div class="t-body3 mgt-4">
                {{review.content}}
                <div class="mgt-3">
                    <span class="t-helper">
                        {{review.reviewer.name ? review.reviewer.name.fullName : $t("S10082")}}
                    </span>
                    <span class="t-caption">
                        {{$moment(review.created).fromNow()}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 리뷰 목록 아이템 컴포넌트(review list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
    props: ['review']
}
</script>
